import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "typeDropdown",
    "workoutContainer",
    "videoContainer",
    "workoutDropdown",
    "videoDropdown",
  ];

  connect() {
    this.toggleItemDropdown();
  }

  toggleItemDropdown() {
    const isWorkout = this.typeDropdownTarget.value === "Workout";

    this.workoutContainerTarget.style.display = isWorkout ? "block" : "none";
    this.videoContainerTarget.style.display = isWorkout ? "none" : "block";

    // Only the active dropdown should submit its item_id; disabled fields
    // are excluded from the form payload so they don't clobber each other.
    this.workoutDropdownTarget.disabled = !isWorkout;
    this.videoDropdownTarget.disabled = isWorkout;
  }
}
